import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["method", "account"]
  static values = { defaults: Object }

  changeMethod() {
    this.accountTarget.value = this.defaultsValue[this.methodTarget.value] || ""
    this.accountTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
